import { request } from "../utils/request.js"

export const getShareConfig = (url) => request({
    url: 'wxOffiAcc/getSignature',
    method: 'GET',
    params: { url },
})

export const login = (id) => request({
    url: 'user/login',
    method: 'GET',
    params: { id },
})




// WEBPACK FOOTER //
// ./src/api/api.js